import AdminDataTable from "../../core/DataTable/DataTable";

export function CommentsList() {
    return <AdminDataTable
        collection="comments"
        columns={[
            {
                name: "ID",
                field: "id",
                type: "text",
                edit: false,
            },
            {
                name: "Comment",
                field: "text",
                type: "text",
            },
            {
                name: "Username",
                field: "username",
                type: "text",
                edit: false,
            },
            {
                name: "UserID",
                field: "userID",
                type: "text",
                edit: false,
            },
            {
                name: "User Photo",
                field: "userphoto",
                type: "image",
                edit: false,
            },
            {
                name: "BlogID",
                field: "blogId",
                type: "text",
                edit: false,
            },
            {
                name: "Blog Title",
                field: "blogTitle",
                type: "text",
                show: false,
            },
            {
                name: "Blog Description",
                field: "blogDescription",
                type: "text",
                show: false,
            },
            {
                name: "Created At",
                field: "createdAt",
                type: "datetime",
                edit: false,
            },
            {
                name: "Updated At",
                field: "updatedAt",
                type: "datetime",
                edit: false,
            },
        ]}
     />
}